export default "__VITE_PUBLIC_ASSET__ad7b5a38__"